<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header v-if="type == 1" :headerName="'Lista de Dias do Turno'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/lista-turnos-ciclico/' + companyId" :css="'container'"/>
      <page-header v-if="type == 2" :headerName="'Lista de Dias do Turno'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/lista-turnos/' + companyId" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- No Result -->
            <div v-if="!loading && !dataWorkShift.length && !failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum dia para exibir.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataWorkShift.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="portlet light">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de dias ({{ dataWorkShift.length }})</span>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-bottom-20 offset-top-10">
                  <div class="checkbox">
                    <input type="checkbox" id="checkbox" v-model="checked" v-on:click="selectAllCheck()">
                    <label
                      v-bind:style="{'font-weight': '600', 'font-size': '13px', 'color': '#93a2a9', 'padding-left': '10px'}"
                      for="checkbox">SELECIONAR TODOS</label>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> SELECIONE</th>
                        <th> ID</th>
                        <th> dayOfWeek</th>
                        <th> firstPeriodDuration</th>
                        <th> turnOffShiftDay</th>
                        <th> workingDayTotal</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataWorkShift">
                        <td>
                          <div class="checkbox">
                            <input v-on:click="addRemoveUser(c)" v-bind:id="c.code" type="checkbox">
                            <label></label>
                          </div>
                        </td>
                        <td>{{ c.workShiftDayId }}</td>
                        <td>{{ c.dayOfWeek }}</td>
                        <td>{{ c.firstPeriodDuration }}</td>
                        <td>{{ c.turnOffShiftDay }}</td>
                        <td>{{ c.workingDayTotal }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Box Filter -->
            <div v-if="listFromWs.length" class="container">
              <div class="row">
                <div class="col-md-12 box-content offset-top-20 offset-bottom-40">
                  <!--Info -->
                  <div class="col-md-12">
                    <div class="info-card-blue">
                      <div>1</div>
                      <div>TURNOS SELECIONADOS</div>
                      <div>Alterar duração do primeiro período e horário de troca de turno</div>
                    </div>
                  </div>

                  <!-- List User Selected -->
                  <div class="col-md-12">
                    <div class="col-md-12 box-list-user-selected">
                      <div class="col-md-12 padding-null">
                        <p class="list-user">Lista de turnos selecionados.
                          <span v-on:click="removeAllUser()" class="remove-all">
                          <span>Remover todos</span>
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </span>
                        </p>
                      </div>

                      <div v-for="u in listFromWs" class="col-md-3">
                        <div class="user-selected">
                          <span>{{ u.dayOfWeek }}</span>
                          <span v-on:click="removeUserFromCode(u.code)" title="Remover da lista"><i
                            class="icon-close"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 offset-top-10">
                    <form>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label>firstPeriodDuration</label>
                          <input v-model="dataChange.firstPeriodDuration" type="text" class="form-control"
                                 name="firstPeriodDuration" placeholder="00:00" required>
                          <span v-if="dataError.firstPeriodDuration"
                                class="error-msg">{{ dataError.firstPeriodDuration }}</span>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="form-group">
                          <label>turnOffShiftDay</label>
                          <input v-model="dataChange.turnOffShiftDay" type="text" class="form-control"
                                 name="turnOffShiftDay" placeholder="00:00" required>
                          <span v-if="dataError.turnOffShiftDay"
                                class="error-msg">{{ dataError.turnOffShiftDay }}</span>
                        </div>
                      </div>
                    </form>
                  </div>

                  <!-- Values -->
                  <div class="col-md-12">
                    <form name="form" class="form-filter" novalidate>
                      <!-- Inputs -->
                      <div class="col-md-12 padding-null">
                        <!-- Button Search -->
                        <div class="col-md-12 offset-top-20 offset-bottom-20">
                          <button v-bind:disabled="loadingChange" v-on:click="changeWsDay()" class="default-btn-bue"
                                  type="button">
                            <div v-if="loadingChange" class="loading-btn">
                              <div class="spinner-btn">
                                <div class="rect1"></div>
                                <div class="rect2"></div>
                                <div class="rect3"></div>
                                <div class="rect4"></div>
                                <div class="rect5"></div>
                              </div>
                            </div>
                            <span v-else>Enviar</span>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  GET_WS_DAY,
  CHANGE_WS_DAY
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "work-shift-by-company",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      companyId: this.$route.params.idCompany,
      context: this.$route.params.context,
      type: this.$route.params.type,
      reloadPageDay: 0,
      checkAll: false,
      checked: false,
      loading: false,
      failRequest: false,
      dataWorkShift: [],
      qtdWorkShift: 30,
      listFromWs: [],
      loadingChange: false,
      wsSelectedDay: null,
      dataError: {
        firstPeriodDuration: null,
        turnOffShiftDay: null
      },
      dataChange: {
        firstPeriodDuration: null,
        turnOffShiftDay: null
      }
    }
  },
  methods: {
    getIndexesFromList(list) {
      let newList = [];
      for (let i in list) {
        if (typeof list[i].code === "number" && newList.indexOf(list[i].code) === -1)
          newList.push(list[i].code)
      }
      return newList;
    },
    selectAllCheck() {
      this.checked = !this.checked;
      if (this.checked) {
        let indexes = this.getIndexesFromList(this.listFromWs);
        this.dataWorkShift.map((value, index) => {
          $("#" + value.code).prop("checked", true);

          if (indexes.indexOf(value.code) === -1) {
            value.id = value.workShiftDayId;
            this.listFromWs.push(value);
          }
        });
      } else {
        this.dataWorkShift.map((value, index) => {
          this.listFromWs = [];
          $("#" + value.code).prop("checked", false);
        });
      }
    },
    addRemoveUser(c) {
      let obj = {
        id: c.workShiftDayId,
        code: c.code,
        dayOfWeek: c.dayOfWeek
      };
      let indexes = this.getIndexesFromList(this.listFromWs);
      if (indexes.indexOf(obj.code) === -1) {
        this.listFromWs.push(obj);
      } else {
        this.listFromWs.splice(indexes.indexOf(obj.code), 1);
      }
    },
    removeAllUser() {
      this.checked = false;
      this.dataWorkShift.map((value, index) => {
        this.listFromWs = [];
        $("#" + value.code).prop("checked", false);
      });
    },
    removeUserFromCode(code) {
      let indexes = this.getIndexesFromList(this.listFromWs);
      this.listFromWs.splice(indexes.indexOf(code), 1);
      $("#" + code).prop("checked", false);
    },
    getWorkShiftByCompany() {
      this.loading = true;

      let url = GET_WS_DAY + "?workshiftId=" + this.$route.params.idWs;
      REQUEST_SERVICE.requestContext('GET', url, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT GET_WS_DAY:", response.data);

        response.data.map((value, index) => {
          value.code = index;
          this.dataWorkShift.push(value);
        });

        this.loading = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    changeWsDay() {
      this.dataError.firstPeriodDuration = "";
      this.dataError.turnOffShiftDay = "";

      if (this.dataChange.firstPeriodDuration && this.dataChange.turnOffShiftDay) {
        let objSend = [];
        this.loadingChange = true;

        this.listFromWs.map((value, index) => {
          objSend.push({
            workShiftDayId: value.id,
            firstPeriodDuration: this.dataChange.firstPeriodDuration,
            turnOffShiftDay: this.dataChange.turnOffShiftDay
          });

          if (this.listFromWs.length === index + 1) {

            UTIL_SERVICE.console("DATA SEND:", objSend);
            REQUEST_SERVICE.requestContext('PUT', CHANGE_WS_DAY, this.context, objSend).then((response) => {
              UTIL_SERVICE.console("RESULT CHANGE_WS_DAY:", response);
              this.loadingChange = false;

              swal("Aviso", "Turno atualizado com sucesso.", "success");
            }).catch((reason) => {
              this.loadingChange = false;

              reason.response.data.erros.map((value, index) => {
                swal("Aviso", value.value, "error");
              });
            });
          }
        });
      } else {
        if (!this.dataChange.firstPeriodDuration) {
          this.dataError.firstPeriodDuration = "Campo obrigatório";
        }

        if (!this.dataChange.turnOffShiftDay) {
          this.dataError.turnOffShiftDay = "Campo obrigatório";
        }
      }
    }
  },
  beforeMount() {
    this.getWorkShiftByCompany();
  },
  watch: {
    reloadPageDay: function (val) {
      this.getWorkShiftByCompany();
    }
  }
}
</script>

<style lang="scss">
.error-msg {
  font-size: 12px;
  color: #e74a4e;
  text-align: left;
  display: block;
}

.search-employers {
  position: absolute;
  right: 0;
  margin-top: 10px;

  .user-disabled {
    position: absolute;
    top: -55px;
    cursor: pointer;
    color: #837d7d;
    border-bottom: 1px solid #bdb3b3;

    &:hover {
      text-decoration: none;
    }
  }

  label {
    display: block;
    font-weight: 600;
    letter-spacing: 1px;
  }

  input {
    display: inline-block;
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 50%;
  }

  button {
    background: #3598dc;
    color: #ffffff;
    text-decoration: none;
    margin-right: 30px;
    border-radius: 4px !important;
    border: none;
    font-weight: 600;
    display: inline-block;
    height: 33px;
    line-height: 34px;
    margin-left: 0;
    padding: 0 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/listWorkShiftDay.vue